import React from 'react'
import Footer from 'components/Footer'

const Policy = () => {
    return (
        <div>
        <div className='container py-8'>
            <div className='max-w-6xl mx-auto px-8'>
                <h2 className='text-4xl font-bold text-center pb-8 pt-5'>Minterminds - We Value Your Privacy.
                </h2>
                At Minterminds, we are committed to safeguarding the privacy of our users. This Privacy Policy outlines the information we collect, how we use it, and the choices you have concerning your information.

                <h2 className='text-xl font-bold my-3 text-[#0e2b5c]'>
                    Information We Collect
                </h2>
                Personal Information: When you use our services or interact with our website, we may collect personal information such as your name, email address, contact details, and payment information.
                Usage Data: We gather information about how you interact with our software, including log data, device information, IP addresses, and cookies, to enhance our services and user experience.
                <h5 className='text-xl font-bold my-3 text-[#0e2b5c]'>

                    How We Use Your Information
                </h5>
                Providing Services: Your information is used to provide, maintain, and improve our software products and services, including customer support, updates, and new features.
                Communication: We may use your contact details to send you important updates, newsletters, marketing materials, or respond to inquiries.
                Analytics: Analyzing user behavior helps us understand how our services are used, allowing us to optimize and personalize our offerings.
                <h5 className='text-xl font-bold my-3 text-[#0e2b5c]'>

                    Data Security
                </h5>
                We implement appropriate security measures to protect your information from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is completely secure, and we cannot guarantee absolute security.
                <h5 className='text-xl font-bold my-3 text-[#0e2b5c]'>

                    Third-Party Disclosure
                </h5>
                We do not sell, trade, or otherwise transfer your personal information to outside parties unless we provide users with advance notice. This excludes trusted third parties who assist us in operating our website, conducting our business, or servicing you, as long as those parties agree to keep this information confidential.
                
                Your Choices
                
                You have the right to access, correct, or delete your personal information held by Minterminds. You may also opt out of receiving marketing communications from us.
                <h5 className='text-xl font-bold my-3 text-[#0e2b5c]'>
                    Updates to Privacy Policy
                </h5>

                Minterminds reserves the right to modify this Privacy Policy at any time. We encourage you to review this Policy periodically for any changes.
                <h5 className='text-xl font-bold my-2 text-[#0e2b5c]'>
                    Information We Collect
                </h5>
               <h5> <strong> Personal Information:</strong></h5> When you register for our services, we may collect personal details such as your name, email address, billing information, and demographic data.
                Usage and Technical Information: We gather information about your interactions with our software, including device information, IP addresses, browser type, pages visited, and the duration of your visits.
                Cookies and Tracking Technologies: We utilize cookies and similar tracking technologies to enhance user experience, gather analytics, and customize our services. You can manage cookie preferences through your browser settings.
                How We Use Your Information
               
                    <h5><strong> Service Provision:</strong></h5> We use collected information to deliver and maintain our services, process payments, and offer customer support.
                    Personalization: Analyzing user data allows us to tailor our offerings, recommend relevant content, and improve user experience.
                    Communication: We may contact you regarding important updates, or promotions, or to respond to inquiries and requests.
                    Data Security

                    We employ industry-standard security measures to protect your information. However, please note that no method of transmission over the Internet or electronic storage is entirely secure.
                    <h5 className='text-xl font-bold my-2 text-[#0e2b5c]'>
                        Third-Party Disclosure
                    </h5>
                    We do not sell, trade, or transfer your personal information to outside parties without your consent, except to trusted third parties assisting us in operating our website, conducting our business, or serving you, provided they agree to keep your information confidential.
               
                Your Choices
                
                Access and Control: You have the right to access, modify, or delete your personal information stored by Minterminds. You can manage your communication preferences or opt out of marketing communications.
                Do Not Track Signals: We do not support “Do Not Track” signals as there is no universally accepted standard for such signals.
                Updates to Privacy Policy

                Minterminds may update this Privacy Policy periodically. Significant changes will be notified through our website or via email.
                <h5 className='text-xl font-bold my-2 text-[#0e2b5c]'>
                    Children’s Privacy
                </h5>

                Our services are not directed to children under 13. We do not knowingly collect personal information from children. If you believe that we have inadvertently collected information from a child, please contact us to remove the information.
                <h5 className='text-xl font-bold my-2 text-[#0e2b5c]'>
                    Contact Us
                </h5>
                If you have any questions or concerns about this Privacy Policy or our data practices, please get in touch with us at [info@minterminds.com].
                
                This Privacy Policy was last updated on 25th November 2023



            </div>
        </div>
        <Footer />
        </div>
    )
}

export default Policy
